import {
    FETCH_NOTIFICATIONS_REQUEST,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILURE,

    READ_NOTIFICATION_REQUEST,
    UNREAD_NOTIFICATION_REQUEST,
    READ_ALL_NOTIFICATIONS_REQUEST
} from './Types';
import { INotificationAction, INotificationReducerState } from './notificationTypes';

const defaultState = {
    isFetchingNotifications: false,
    fetchingNotificationsError: null,
    notifications: []
};

export default function reducer (state:INotificationReducerState = defaultState, action:INotificationAction) {
    switch (action.type) {
        case FETCH_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                isFetchingNotifications: true
            };
        case FETCH_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: action.notifications,
                fetchingNotificationsError: null,
                isFetchingNotifications: false
            };
        case FETCH_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                fetchingNotificationsError: action.error,
                isFetchingNotifications: false
            };
        case READ_NOTIFICATION_REQUEST:
        case UNREAD_NOTIFICATION_REQUEST: {
            const notificationIdx = state.notifications.findIndex(n => n.id === action.id);
            const newNotifications = [...state.notifications];
            newNotifications[notificationIdx] = {
                ...newNotifications[notificationIdx],
                read: action.read
            };
            return {
                ...state,
                notifications: newNotifications
            };
        }
        case READ_ALL_NOTIFICATIONS_REQUEST: {
            return {
                ...state,
                notifications: state.notifications.map(n => ({
                    ...n,
                    read: true
                }))
            };
        }
        default:
            return state;
    }
}